import { developmentPlanConstants } from '../../_constants';

const initialState = { RelationListLoading: true, data: '', error: false };

export function relationList(state = initialState, action) {
    
    switch (action.type) {
        case developmentPlanConstants.REQUEST_RELATION_LIST:
            return {
                RelationListLoading: true,
                data: '',
                error: false
            };
        case developmentPlanConstants.RECEIVE_RELATION_LIST:
            return {
                RelationListLoading: false,
                data: action.RelationList,
                error: false
            };
        case developmentPlanConstants.RELATION_LIST_ERROR:
            return {
                RelationListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/developmentPlan/getRelationList.reducer.js